import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'timeAgo'
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: string): string {
    const localDate = moment.utc(value).local().toString();
    const currentDate: Date = new Date();
    const inputDate: Date = new Date(localDate);
    const seconds: number = Math.floor((currentDate.getTime() - inputDate.getTime()) / 1000);
    let interval: number = Math.floor(seconds / 31536000);

    if (interval >= 1) {
      return interval === 1 ? 'a year ago' : `${interval} years ago`;
    }
    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
      return interval === 1 ? 'a month ago' : `${interval} months ago`;
    }
    interval = Math.floor(seconds / 86400);
    if (interval >= 1) {
      return interval === 1 ? 'a day ago' : `${interval} days ago`;
    }
    interval = Math.floor(seconds / 3600);
    if (interval >= 1) {
      return interval === 1 ? 'an hour ago' : `${interval} hours ago`;
    }
    interval = Math.floor(seconds / 60);
    if (interval >= 1) {
      return interval === 1 ? 'a minute ago' : `${interval} minutes ago`;
    }
    return `${Math.floor(seconds)} seconds ago`;
  }
}
